// determineOsNotificationPermissionValue
/**
 * No-op on web; Only relevant in ios|android files.
 *
 * @see determineOsNotificationPermissionValue.ios|android
 */

import { NO_OP_MESSAGE__NATIVE } from '../utils/constants';

import { DetermineOsNotificationPermissionValue } from './types';

export const determineOsNotificationPermissionValue: DetermineOsNotificationPermissionValue = () => {
  throw Error(NO_OP_MESSAGE__NATIVE); // optional
};
